// extracted by mini-css-extract-plugin
export default {"attention":"billing-details_attention__ap14Y"};